import { render, staticRenderFns } from "./liveCreatePage.vue?vue&type=template&id=80072222&"
import script from "./liveCreatePage.vue?vue&type=script&lang=ts&"
export * from "./liveCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports